import * as React from 'react';
import { Dialog } from '../../Common/Dialog';
import { Button } from '../../Forms/Button';
import './style.css';

export interface PremiumVideoPopupProps {
  onClose: () => void;
  /**
   * Request sign-up for premier membership
   */
  onRequestSignUp: () => void;
}

export interface PremiumVideoPopupState {
  /* empty*/
}

export class PremiumVideoPopup extends React.Component<
  PremiumVideoPopupProps,
  PremiumVideoPopupState
> {
  render() {
    const { onClose, onRequestSignUp } = this.props;

    return (
      <Dialog
        dialogClassName="premium-video-popup"
        title={'Edge of Play - Subscription Required'}
        onClose={onClose}
      >
        <div className="premium-video-popup-info">
          <p>
            Subscription to Edge of Play gives you access to hundreds of
            coaching videos and resources from grassroots coaches, professional
            clubs, academies and players and supports our grassroots coaching
            platform
          </p>
        </div>
        <Button
          className="premium-video-sign-up-button"
          onClick={onRequestSignUp}
        >
          Sign up now
        </Button>
      </Dialog>
    );
  }
}

export default PremiumVideoPopup;



// WEBPACK FOOTER //
// ./src/app/components/Premium/PremiumVideoPopup/index.tsx